/* eslint-disable no-param-reassign */
import axios from 'axios';
import * as TokenService from 'services/token/index';

const api = axios.create({
  baseURL: process.env.API_URL,
});
let refreshSubscribers = [];


const APIRefreshAccessToken = async (triiderUser) => {
  try {
    const { refreshToken } = triiderUser;
    const { data } = await api.post('/refresh-token', { refreshToken });
    return data;
  } catch (error) {
    throw error;
  }
};


const setRefreshToken = async (config) => {
  const isRefreshing = TokenService.getRefreshMutex();

  if (!isRefreshing) {
    try {
      TokenService.setRefreshMutex(true);
      const triiderUser = TokenService.getUser();
      const { token, refreshToken } = await APIRefreshAccessToken(triiderUser);

      TokenService.updateLocalTokens(token, refreshToken);
      config.headers = {
        ...config.headers,
        'api-token': token,
      };

      refreshSubscribers.forEach(subscriber => subscriber(token));

      refreshSubscribers = [];

      return api.request(config);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    } finally {
      TokenService.deleteRefreshMutex();
    }
  } else {
    return new Promise((resolve) => {
      refreshSubscribers.push((newAccessToken) => {
        config.headers['api-token'] = newAccessToken;

        resolve(api(config));
      });
    });
  }
};


api.interceptors.request.use(
  (config) => {
    const triiderUser = TokenService.getUser();

    if (triiderUser && triiderUser.token) {
      config.headers = {
        ...config.headers,
        'api-token': triiderUser.token,
        source: 'company',
        selected_company_id: triiderUser.company && triiderUser.company.id,
      };
    }

    return config;
  },
  error => Promise.reject(error),
);

api.interceptors.response.use(
  response => response,
  async (error) => {
    const { config, response } = error;

    if (response && response.status === 403) {
      TokenService.deleteUser();
      TokenService.deleteRefreshMutex();
      window.location.reload();
    }

    if (response && response.status === 401) {
      return setRefreshToken(config);
    }

    return Promise.reject(error);
  },
);


export default api;
